import { booleanResultResolver, useAbeetResult } from '@clutter/abeet';

import { useAbeetVisitorTest } from '@shared/abeet';

export function useCouponDefaultTest() {
  const result = useAbeetResult('web_visitor_coupon_default');
  return result
    ? {
        promoCode: result.promo_code,
        expirationDate: result.expiration_date,
      }
    : {};
}

export function useCalendarCouponTest() {
  return (
    useAbeetVisitorTest('web_visitor_calendar_coupon', {
      resolver: booleanResultResolver('enabled'),
    })[0] || false
  );
}

export function useTieredStoragePricing() {
  return (
    useAbeetVisitorTest('web_visitor_labor', {
      resolver: booleanResultResolver('tiered_pricing'),
    })[0] || false
  );
}
